export default "__VITE_ASSET__DzwXbeix__"